export default __webpack_public_path__ + "static/media/2508114.1765d8b4.png";